import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import Script from "next/script";
import React, { Fragment } from "react";
import XLandingPage from "../../components/employer/XLandingPage/XLandingPage";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import EmployerNavbar from "../../components/shared/SharedNavbar/Navbar/EmployerNavbar";
import * as config from "../../config/config";

function HiredlyX(props) {
  let metaTitle = "Hiredly X | Hiredly Malaysia";
  let metaDescription =
    "Check out our recruitment products and pricing options. Flexible, affordable, and designed to help employers hire effectively.";

  return (
    <Fragment>
      <Head>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/hiredly-x"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/hiredly-x"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="canonical" href="https://my.hiredly.com/hiredly-x" />
      </Head>

      {/* Respond.io WhatsApp Widget Script*/}
      <Script
        id="respondio__growth_tool"
        src={`https://cdn.respond.io/widget/widget.js?wId=${config.respondIOWidgetId}`}
        strategy="lazyOnload"
      />

      {/* Google tag (gtag.js) */}
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=AW-17057663570"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17057663570');
        `}
      </Script>

      <Script>
        {`function gtag_report_conversion(url) { var callback = function () { if (typeof(url) != 'undefined') { window.location = url; } }; gtag('event', 'conversion', { 'send_to': 'AW-17057663570/ir5XCOiFw5gbENKU3cU_', 'event_callback': callback }); return false; }`}{" "}
      </Script>

      <ToResolveClassNameError>
        <EmployerNavbar />
        <Toolbar />
      </ToResolveClassNameError>
      <XLandingPage />
    </Fragment>
  );
}

export default HiredlyX;
